import React from 'react';
import { Card } from './ui/card';
import { careTypes } from '../data/mockData';

const AgesSection = () => {
  // Split careTypes into categories
  const lichamelijk = careTypes.filter(c => c.title === 'Lichamelijke beperking');
  const verstandelijk = careTypes.filter(c => ['ASS', 'ADHD', 'Gedragsproblematiek'].includes(c.title));

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16">
          <h3 className="text-xl md:text-2xl text-gray-600 mb-2" style={{ fontFamily: 'Quicksand, sans-serif' }}>
            Voor wie
          </h3>
          <h2
            className="text-4xl md:text-6xl font-bold text-[#1A4D4D] mb-4"
            style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}
          >
            onze zorg is er voor jongeren met
          </h2>
        </div>

        {/* Lichamelijke beperking */}
        <div className="mb-12">
          <h3 className="text-2xl md:text-3xl font-bold text-[#1A4D4D] mb-6 text-center" style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}>
            Lichamelijke beperking
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6 mb-8 max-w-md mx-auto">
            {lichamelijk.map((group) => (
              <Card
                key={group.id}
                className="group relative overflow-hidden rounded-3xl border-none shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={group.image}
                    alt={group.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div
                    className="absolute inset-0 transition-opacity duration-300"
                    style={{ backgroundColor: group.color }}
                  />
                </div>
                <div className="p-6 bg-white">
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {group.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Leeftijd</p>
                      <p className="font-bold text-[#1A4D4D]">{group.ageRange}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Beschikbaar</p>
                      <p className="font-bold" style={{ color: group.buttonColor }}>
                        {group.details}
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Verstandelijke beperking */}
        <div className="mb-12">
          <h3 className="text-2xl md:text-3xl font-bold text-[#1A4D4D] mb-6 text-center" style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}>
            Verstandelijke beperking
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {verstandelijk.map((group) => (
              <Card
                key={group.id}
                className="group relative overflow-hidden rounded-3xl border-none shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={group.image}
                    alt={group.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div
                    className="absolute inset-0 transition-opacity duration-300"
                    style={{ backgroundColor: group.color }}
                  />
                </div>
                <div className="p-6 bg-white">
                  <h3 className="text-2xl font-bold text-[#1A4D4D] mb-3">{group.title}</h3>
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {group.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Leeftijd</p>
                      <p className="font-bold text-[#1A4D4D]">{group.ageRange}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Beschikbaar</p>
                      <p className="font-bold" style={{ color: group.buttonColor }}>
                        {group.details}
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>

      {/* Decorative tree illustration */}
      <div className="absolute bottom-10 left-10 opacity-10 hidden lg:block">
        <svg width="120" height="180" viewBox="0 0 120 180" fill="none">
          <circle cx="60" cy="50" r="40" fill="#52BE80" />
          <circle cx="35" cy="75" r="30" fill="#52BE80" />
          <circle cx="85" cy="70" r="33" fill="#52BE80" />
          <rect x="52" y="100" width="16" height="80" fill="#A0826D" />
        </svg>
      </div>
    </section>
  );
};

export default AgesSection;